import { convertSecondsToHours } from 'src/utilities';
import { PumpModalData, RangePumpData } from '../types';

export const formatPumpReportData = (data: RangePumpData[]) => {
  const reportPumpData: PumpModalData[] = [];
  data.forEach((report: RangePumpData) => {
    const dailyRuntimeInHours = convertSecondsToHours(
      report.reportData.dailyRuntime ? +report.reportData.dailyRuntime : 0,
      2
    );

    const pumpData: PumpModalData = {
      date: report.date,
      site: report.asset.site,
      asset: report.asset.assetName,
      runtime: dailyRuntimeInHours,
      cycles: report.reportData.dailyCycles ? report.reportData.dailyCycles : '-',
      flow: report.reportData.dailyVolumetricFlow ? report.reportData.dailyVolumetricFlow : '-',
      efficiency: report.reportData.averageDailyEfficiency
        ? report.reportData.averageDailyEfficiency
        : '-',
      energyConsumption: report.reportData.dailyEnergyConsumption
        ? report.reportData.dailyEnergyConsumption
        : '-',
    };
    reportPumpData.push(pumpData);
  });

  return reportPumpData;
};
